export default "__VITE_ASSET__B6uGBrdO__"